var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.purchase
    ? _c(
        "div",
        [
          _c(
            "b-container",
            { staticClass: "main_layer py-2", attrs: { fluid: "" } },
            [
              _c("b-container", [
                _c("p", { staticClass: "fs-40 fw-600 white-color my-2" }, [
                  _vm._v(
                    "Преобразование закупки 44ФЗ с неопределённым объёмом № " +
                      _vm._s(_vm.purchase.reg_number) +
                      " в несрочную"
                  ),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "b-container",
            { staticClass: "my-2", attrs: { fluid: "" } },
            [
              _c(
                "b-container",
                [
                  _c("text-header", [_vm._v("Информация о заказчике")]),
                  _c("text-row-link", {
                    attrs: {
                      compact: "",
                      "label-cols-lg": 4,
                      "label-cols-sm": 4,
                      label: "Наименование",
                      "router-link": {
                        name: "OrganizationShow",
                        params: { id: _vm.purchase.customer.id },
                      },
                    },
                    model: {
                      value: _vm.purchase.customer.full_name,
                      callback: function ($$v) {
                        _vm.$set(_vm.purchase.customer, "full_name", $$v)
                      },
                      expression: "purchase.customer.full_name",
                    },
                  }),
                  _c("text-row", {
                    attrs: {
                      compact: "",
                      "label-cols-lg": 4,
                      "label-cols-sm": 4,
                      label: "ИНН",
                    },
                    model: {
                      value: _vm.purchase.customer.inn,
                      callback: function ($$v) {
                        _vm.$set(_vm.purchase.customer, "inn", $$v)
                      },
                      expression: "purchase.customer.inn",
                    },
                  }),
                  _c("text-row", {
                    attrs: {
                      compact: "",
                      "label-cols-lg": 4,
                      "label-cols-sm": 4,
                      label: "КПП",
                    },
                    model: {
                      value: _vm.purchase.customer.kpp,
                      callback: function ($$v) {
                        _vm.$set(_vm.purchase.customer, "kpp", $$v)
                      },
                      expression: "purchase.customer.kpp",
                    },
                  }),
                  _c("text-row", {
                    attrs: {
                      compact: "",
                      "label-cols-lg": 4,
                      "label-cols-sm": 4,
                      label: "ОГРН",
                    },
                    model: {
                      value: _vm.purchase.customer.ogrn,
                      callback: function ($$v) {
                        _vm.$set(_vm.purchase.customer, "ogrn", $$v)
                      },
                      expression: "purchase.customer.ogrn",
                    },
                  }),
                  _c("text-row", {
                    attrs: {
                      compact: "",
                      "label-cols-lg": 4,
                      "label-cols-sm": 4,
                      label: "Юридический адрес",
                    },
                    model: {
                      value: _vm.purchase.customer.legal_address,
                      callback: function ($$v) {
                        _vm.$set(_vm.purchase.customer, "legal_address", $$v)
                      },
                      expression: "purchase.customer.legal_address",
                    },
                  }),
                  _vm.purchase.purchase_terms.contact_info
                    ? _c("text-row", {
                        attrs: {
                          compact: "",
                          "label-cols-lg": 4,
                          "label-cols-sm": 4,
                          label: "Дополнительная контактная информация",
                        },
                        model: {
                          value: _vm.purchase.purchase_terms.contact_info,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.purchase.purchase_terms,
                              "contact_info",
                              $$v
                            )
                          },
                          expression: "purchase.purchase_terms.contact_info",
                        },
                      })
                    : _vm._e(),
                  _c("text-header", [_vm._v("Условия закупки")]),
                  _c("text-row", {
                    attrs: {
                      compact: "",
                      "label-cols-lg": 4,
                      "label-cols-sm": 4,
                      label: "Предмет закупки",
                      value: _vm.purchase.purchase_terms.deliverable_group.name,
                    },
                  }),
                  _c("text-row", {
                    attrs: {
                      compact: "",
                      "label-cols-lg": 4,
                      "label-cols-sm": 4,
                      label: "Объект закупки",
                      value: _vm.purchase.purchase_terms.purchase_object,
                    },
                  }),
                  _c("text-row", {
                    attrs: {
                      compact: "",
                      "label-cols-lg": 4,
                      "label-cols-sm": 4,
                      label: "Тип закупки",
                      value: _vm.purchase.purchase_terms.order_type.name,
                    },
                  }),
                  _c("text-row", {
                    attrs: {
                      compact: "",
                      "label-cols-lg": 4,
                      "label-cols-sm": 4,
                      label: "Продолжительность закупочной сессии",
                      value: _vm.purchase.purchase_terms.duration_type.name,
                    },
                  }),
                  _c("text-row", {
                    attrs: {
                      compact: "",
                      "label-cols-lg": 4,
                      "label-cols-sm": 4,
                      label: "Размер аванса, %",
                      value: _vm.purchase.purchase_terms.advance_percentage,
                    },
                  }),
                  _c("text-row-price", {
                    attrs: {
                      compact: "",
                      "label-cols-lg": 4,
                      "label-cols-sm": 4,
                      label: "Цена контракта",
                      value: _vm.purchase.purchase_terms.contract_price,
                    },
                  }),
                  _c("text-row-date", {
                    attrs: {
                      compact: "",
                      "label-cols-lg": 4,
                      "label-cols-sm": 4,
                      label: "Планируемая дата заключения договора",
                      value:
                        _vm.purchase.purchase_terms
                          .planned_contract_conclusion_date,
                    },
                  }),
                  _c("text-row-date", {
                    attrs: {
                      compact: "",
                      "label-cols-lg": 4,
                      "label-cols-sm": 4,
                      label: "Планируемая дата исполнения договора",
                      value:
                        _vm.purchase.purchase_terms
                          .planned_contract_execution_date,
                    },
                  }),
                  _c("text-row-single-document", {
                    attrs: {
                      compact: "",
                      "label-cols-lg": 4,
                      "label-cols-sm": 4,
                      label: "Проект ГК",
                      value:
                        _vm.purchase.purchase_terms.contract_draft_attachment,
                    },
                  }),
                  _vm.purchase.purchase_terms
                    .commercial_proposal_form_attachment
                    ? _c("text-row-single-document", {
                        attrs: {
                          compact: "",
                          "label-cols-lg": 4,
                          "label-cols-sm": 4,
                          label:
                            "Образец коммерческого предложения для заполнения",
                          value:
                            _vm.purchase.purchase_terms
                              .commercial_proposal_form_attachment,
                        },
                      })
                    : _vm._e(),
                  _vm.purchase.additional_documents.length > 0
                    ? _c("text-row-documents", {
                        attrs: {
                          compact: "",
                          "label-cols-lg": 4,
                          "label-cols-sm": 4,
                          label: "Дополнительные документы",
                        },
                        model: {
                          value: _vm.purchase.additional_documents,
                          callback: function ($$v) {
                            _vm.$set(_vm.purchase, "additional_documents", $$v)
                          },
                          expression: "purchase.additional_documents",
                        },
                      })
                    : _vm._e(),
                  _c("text-row", {
                    attrs: {
                      compact: "",
                      "label-cols-lg": 4,
                      "label-cols-sm": 4,
                      label:
                        "Информация о возможности и случаях одностороннего расторжения сделки в соответствии с действующим законодательством Российской Федерации",
                      value:
                        _vm.purchase.purchase_terms
                          .unilateral_contract_termination_info ?? "Нет",
                      "text-wrap": "",
                    },
                  }),
                  _c("text-header", [
                    _vm._v("Требования к участникам закупки"),
                  ]),
                  _c("text-row-boolean-text", {
                    attrs: {
                      compact: "",
                      "label-cols-lg": 11,
                      "label-cols-sm": 11,
                      label:
                        "Участником закупки могут быть только субъекты малого предпринимательства (СМП)",
                      value: _vm.purchase.supplier_requirements.only_smp,
                      "value-class": "text-right",
                    },
                  }),
                  _c("text-row-boolean-text", {
                    attrs: {
                      compact: "",
                      "label-cols-lg": 11,
                      "label-cols-sm": 11,
                      label:
                        "Установить требование к участникам по рейтингу с возможностью отклонения предложения участника с рейтингом ниже 4,5 балла",
                      value:
                        _vm.purchase.supplier_requirements.supplier_reqs_rating,
                      "value-class": "text-right",
                    },
                  }),
                  _c("text-row-boolean-text", {
                    attrs: {
                      compact: "",
                      "label-cols-lg": 11,
                      "label-cols-sm": 11,
                      label:
                        "Соответствие участника закупки требованиям п.1 ч.1 ст.31 Федерального закона «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» от 05.04.2013 №44-ФЗ",
                      value: _vm.purchase.supplier_requirements.supplier_reqs_a,
                      "value-class": "text-right",
                    },
                  }),
                  _vm.purchase.supplier_requirements.supplier_reqs_a
                    ? _c(
                        "b-container",
                        [
                          _c("text-row", {
                            attrs: {
                              compact: "",
                              "label-cols-lg": 4,
                              "label-cols-sm": 4,
                              label: "Описание требований",
                              value:
                                _vm.purchase.supplier_requirements
                                  .supplier_reqs_a_details.supplier_reqs_a_text,
                              "text-wrap": "",
                            },
                          }),
                          _c(
                            "b-form-group",
                            {
                              staticClass: "mb-0",
                              attrs: {
                                "label-cols-sm": 4,
                                "label-cols-lg": 4,
                                label: "Подтверждающие документы:",
                                "label-class":
                                  "fs-14 grey-color fw-700 d-flex align-items-baseline",
                              },
                            },
                            [
                              _c(
                                "ul",
                                _vm._l(
                                  _vm.purchase.supplier_requirements
                                    .supplier_reqs_a_details
                                    .supplier_reqs_a_documents,
                                  function (item, index) {
                                    return _c(
                                      "li",
                                      {
                                        key: index,
                                        staticClass:
                                          "fs-14 grey-color my-auto col-form-label pb-0",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(index + 1 + ". " + item.name)
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("text-row-boolean-text", {
                    attrs: {
                      compact: "",
                      "label-cols-lg": 11,
                      "label-cols-sm": 11,
                      label:
                        "Соответствие участника закупки требованиям п.3-5, 7-11 ч.1 ст.31 Федерального закона «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» от 05.04.2013 №44-ФЗ",
                      value: _vm.purchase.supplier_requirements.supplier_reqs_b,
                      "value-class": "text-right",
                    },
                  }),
                  _c("text-row-boolean-text", {
                    attrs: {
                      compact: "",
                      "label-cols-lg": 11,
                      "label-cols-sm": 11,
                      label:
                        "Соответствие участника закупки требованиям ч.1.1 ст.31 Федерального закона «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» от 05.04.2013 №44-ФЗ",
                      value: _vm.purchase.supplier_requirements.supplier_reqs_c,
                      "value-class": "text-right",
                    },
                  }),
                  _c("text-row-boolean-text", {
                    attrs: {
                      compact: "",
                      "label-cols-lg": 11,
                      "label-cols-sm": 11,
                      label:
                        "Участник является социально ориентированной некоммерческой организацией (СОНКО)",
                      value:
                        _vm.purchase.supplier_requirements.supplier_reqs_sonko,
                      "value-class": "text-right",
                    },
                  }),
                  _c("text-row-boolean-text", {
                    attrs: {
                      compact: "",
                      "label-cols-lg": 11,
                      "label-cols-sm": 11,
                      label: "Дополнительные требования к участникам закупки",
                      value:
                        _vm.purchase.supplier_requirements
                          .has_additional_requirements,
                      "value-class": "text-right",
                    },
                  }),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.purchase.supplier_requirements
                              .has_additional_requirements,
                          expression:
                            "purchase.supplier_requirements.has_additional_requirements",
                        },
                      ],
                    },
                    [
                      _c("section", { staticStyle: { width: "100%" } }, [
                        _c("div", { staticClass: "table-responsive" }, [
                          _c(
                            "table",
                            { staticClass: "atmo-content-table mb-0" },
                            [
                              _c("thead", [
                                _c("tr", [
                                  _c(
                                    "th",
                                    {
                                      staticClass: "atmo-ctc-width-45pct py-1",
                                    },
                                    [_vm._v("Описание")]
                                  ),
                                  _c(
                                    "th",
                                    {
                                      staticClass: "atmo-ctc-width-45pct py-1",
                                    },
                                    [
                                      _vm._v(
                                        "Причина или цель установки требования"
                                      ),
                                    ]
                                  ),
                                ]),
                              ]),
                              _c(
                                "tbody",
                                _vm._l(
                                  _vm.purchase.supplier_requirements
                                    .additional_requirements,
                                  function (requirement, index) {
                                    return _c("tr", { key: index }, [
                                      _c(
                                        "td",
                                        {
                                          staticClass:
                                            "atmo-ctc-width-45pct py-1",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(requirement.description)
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "td",
                                        {
                                          staticClass:
                                            "atmo-ctc-width-45pct py-1",
                                        },
                                        [_vm._v(_vm._s(requirement.reason))]
                                      ),
                                    ])
                                  }
                                ),
                                0
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]
                  ),
                  _vm.purchase.delivery_terms.addresses.length > 0 ||
                  _vm.purchase.delivery_terms.schedule
                    ? [
                        _c("text-header", [_vm._v("Условия поставки")]),
                        _vm.purchase.delivery_terms.addresses.length > 0
                          ? _c(
                              "b-form-group",
                              {
                                staticClass: "mb-0",
                                attrs: {
                                  "label-cols-sm": 4,
                                  "label-cols-lg": 4,
                                  label: "Адреса для доставки/самовывоза:",
                                  "label-class":
                                    "py-0 fs-14 grey-color fw-700 d-flex align-items-baseline",
                                },
                              },
                              [
                                _c(
                                  "ul",
                                  _vm._l(
                                    _vm.purchase.delivery_terms.addresses,
                                    function (address, index) {
                                      return _c(
                                        "li",
                                        {
                                          key: index,
                                          staticClass:
                                            "py-0 fs-14 grey-color my-auto col-form-label",
                                        },
                                        [_vm._v(_vm._s(address))]
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ]
                            )
                          : _vm._e(),
                        _c("text-row", {
                          attrs: {
                            compact: "",
                            "label-cols-lg": 4,
                            "label-cols-sm": 4,
                            label:
                              "График поставки товаров (выполнения работ, оказания услуг)",
                            value: _vm.purchase.delivery_terms.schedule,
                          },
                        }),
                      ]
                    : _vm._e(),
                  _c("form-row-specification-table-view", {
                    attrs: { "without-count": "" },
                    model: {
                      value: _vm.purchase.deliverables,
                      callback: function ($$v) {
                        _vm.$set(_vm.purchase, "deliverables", $$v)
                      },
                      expression: "purchase.deliverables",
                    },
                  }),
                  _c(
                    "b-row",
                    { staticClass: "my-3 mt-5" },
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "mx-2 text-uppercase",
                              attrs: { variant: "custom-outline-secondary" },
                              on: { click: _vm.onCancel },
                            },
                            [_vm._v("Отменить")]
                          ),
                          _c(
                            "b-button",
                            {
                              staticClass: "text-uppercase mx-2",
                              attrs: {
                                disabled: !_vm.$store.getters.getCanSign,
                                variant: "custom-green",
                              },
                              on: { click: _vm.validateForm },
                            },
                            [_vm._v("Подписать и сохранить")]
                          ),
                          !_vm.$store.getters.getCanSign
                            ? [
                                _vm.$store.getters.getLoginType === "cert"
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "text-danger pl-3 pt-0 fs-14 w-50 my-auto",
                                      },
                                      [
                                        _vm._v(
                                          "Для действия требуется загрузить/заменить МЧД на странице: "
                                        ),
                                        _c(
                                          "router-link",
                                          {
                                            staticClass: "green-link",
                                            attrs: {
                                              to: {
                                                name: "CabinetUserProfile",
                                              },
                                            },
                                          },
                                          [_vm._v("Данные учетной записи")]
                                        ),
                                      ],
                                      1
                                    )
                                  : _c(
                                      "span",
                                      {
                                        staticClass:
                                          "text-danger pl-3 pt-0 fs-14 w-50 my-auto",
                                      },
                                      [
                                        _vm._v(
                                          "Подписание возможно только при авторизации при помощи ЭЦП"
                                        ),
                                      ]
                                    ),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "b-modal",
            {
              ref: "sign-form-modal",
              attrs: {
                centered: "",
                "no-close-on-backdrop": "",
                "no-close-on-esc": "",
                scrollable: "",
                size: "lg",
                title: "Подписать извещение",
              },
              on: { close: _vm.cancelSignModal },
              scopedSlots: _vm._u(
                [
                  {
                    key: "modal-header-close",
                    fn: function () {
                      return [_c("button-close-modal")]
                    },
                    proxy: true,
                  },
                ],
                null,
                false,
                1489420097
              ),
              model: {
                value: _vm.showSignModal,
                callback: function ($$v) {
                  _vm.showSignModal = $$v
                },
                expression: "showSignModal",
              },
            },
            [
              _c(
                "div",
                { staticClass: "d-block text-left" },
                [
                  _c(
                    "b-tabs",
                    { attrs: { "content-class": "mt-3 px-3" } },
                    [
                      _c(
                        "b-tab",
                        {
                          attrs: { active: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "title",
                                fn: function () {
                                  return [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "system_link-style fs-16",
                                      },
                                      [_vm._v("Форма")]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            2602645129
                          ),
                        },
                        [
                          _c("h4", { staticClass: "font-weight-bold" }, [
                            _vm._v("Информация о заказчике"),
                          ]),
                          _c("text-row", {
                            attrs: {
                              compact: "",
                              label: "Наименование организации",
                              value: _vm.purchase.customer.name,
                            },
                          }),
                          _c("text-row", {
                            attrs: {
                              compact: "",
                              label: "ИНН",
                              value: _vm.purchase.customer.inn,
                            },
                          }),
                          _c("text-row", {
                            attrs: {
                              compact: "",
                              label: "КПП",
                              value: _vm.purchase.customer.kpp,
                            },
                          }),
                          _c("text-row", {
                            attrs: {
                              compact: "",
                              label: "ОГРН",
                              value: _vm.purchase.customer.ogrn,
                            },
                          }),
                          _c("text-row", {
                            attrs: {
                              compact: "",
                              label: "Адрес",
                              value: _vm.purchase.customer.legal_address,
                            },
                          }),
                          _c("text-row", {
                            attrs: {
                              compact: "",
                              label: "Дополнительная контактная информация",
                              value: _vm.purchase.purchase_terms.contact_info,
                            },
                          }),
                          _c("hr"),
                          _c("h4", { staticClass: "font-weight-bold" }, [
                            _vm._v("Условия закупки"),
                          ]),
                          _c("text-row", {
                            attrs: {
                              compact: "",
                              "label-cols-lg": 4,
                              "label-cols-sm": 4,
                              label: "Объект закупки",
                              value:
                                _vm.purchase.purchase_terms.purchase_object,
                            },
                          }),
                          _c("text-row", {
                            attrs: {
                              compact: "",
                              "label-cols-lg": 4,
                              "label-cols-sm": 4,
                              label: "Предмет закупки",
                              value:
                                _vm.purchase.purchase_terms.deliverable_group
                                  .name,
                            },
                          }),
                          _c("text-row", {
                            attrs: {
                              compact: "",
                              "label-cols-lg": 4,
                              "label-cols-sm": 4,
                              label: "Тип закупки",
                              value:
                                _vm.purchase.purchase_terms.order_type.name,
                            },
                          }),
                          _c("text-row-price", {
                            attrs: {
                              compact: "",
                              "label-cols-lg": 4,
                              "label-cols-sm": 4,
                              label: "Цена контракта",
                              value: _vm.purchase.purchase_terms.contract_price,
                            },
                          }),
                          _c("text-row", {
                            attrs: {
                              compact: "",
                              "label-cols-lg": 4,
                              "label-cols-sm": 4,
                              label: "Продолжительность закупочной сессии",
                              value:
                                _vm.purchase.purchase_terms.duration_type.name,
                            },
                          }),
                          _c("text-row-boolean-text", {
                            attrs: {
                              compact: "",
                              "label-cols-lg": 4,
                              "label-cols-sm": 4,
                              label: "Аванс",
                              value: _vm.purchase.purchase_terms.with_advance,
                            },
                          }),
                          _vm.purchase.purchase_terms.with_advance
                            ? _c("text-row", {
                                attrs: {
                                  compact: "",
                                  "label-cols-lg": 4,
                                  "label-cols-sm": 4,
                                  label: "Размер аванса",
                                  value:
                                    _vm.purchase.purchase_terms
                                      .advance_percentage + "%",
                                },
                              })
                            : _vm._e(),
                          _c("text-row-date", {
                            attrs: {
                              compact: "",
                              "label-cols-lg": 4,
                              "label-cols-sm": 4,
                              label: "Планируемая дата заключения договора",
                              value:
                                _vm.purchase.purchase_terms
                                  .planned_contract_conclusion_date,
                            },
                          }),
                          _c("text-row-date", {
                            attrs: {
                              compact: "",
                              "label-cols-lg": 4,
                              "label-cols-sm": 4,
                              label: "Планируемая дата исполнения договора",
                              value:
                                _vm.purchase.purchase_terms
                                  .planned_contract_execution_date,
                            },
                          }),
                          _c("text-row-single-document", {
                            attrs: {
                              compact: "",
                              "label-cols-lg": 4,
                              "label-cols-sm": 4,
                              label: "Проект ГК",
                              value:
                                _vm.purchase.purchase_terms
                                  .contract_draft_attachment,
                            },
                          }),
                          _vm.purchase.purchase_terms
                            .commercial_proposal_form_attachment
                            ? _c("text-row-single-document", {
                                attrs: {
                                  compact: "",
                                  "label-cols-lg": 4,
                                  "label-cols-sm": 4,
                                  label:
                                    "Образец коммерческого предложения для заполнения",
                                  value:
                                    _vm.purchase.purchase_terms
                                      .commercial_proposal_form_attachment,
                                },
                              })
                            : _vm._e(),
                          _c("text-row", {
                            attrs: {
                              compact: "",
                              "label-cols-lg": 4,
                              "label-cols-sm": 4,
                              label:
                                "Информация о возможности и случаях одностороннего расторжения сделки в соответствии с действующим законодательством Российской Федерации",
                              value:
                                _vm.purchase.purchase_terms
                                  .unilateral_contract_termination_info,
                              "text-wrap": "",
                            },
                          }),
                          _c("hr"),
                          _c("h4", { staticClass: "font-weight-bold" }, [
                            _vm._v("Требования к участникам закупки"),
                          ]),
                          _c("text-row-boolean-text", {
                            attrs: {
                              compact: "",
                              "label-cols-lg": 11,
                              "label-cols-sm": 11,
                              label:
                                "Участником закупки могут быть только субъекты малого предпринимательства (СМП)",
                              value:
                                _vm.purchase.supplier_requirements.only_smp,
                              "value-class": "text-right",
                            },
                          }),
                          _c("text-row-boolean-text", {
                            attrs: {
                              compact: "",
                              "label-cols-lg": 11,
                              "label-cols-sm": 11,
                              label:
                                "Установить требование к участникам по рейтингу с возможностью отклонения предложения участника с рейтингом ниже 4,5 балла",
                              value:
                                _vm.purchase.supplier_requirements
                                  .supplier_reqs_rating,
                              "value-class": "text-right",
                            },
                          }),
                          _c("text-row-boolean-text", {
                            attrs: {
                              compact: "",
                              "label-cols-lg": 11,
                              "label-cols-sm": 11,
                              label:
                                "Соответствие участника закупки требованиям п.1 ч.1 ст.31 Федерального закона «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» от 05.04.2013 №44-ФЗ",
                              value:
                                _vm.purchase.supplier_requirements
                                  .supplier_reqs_a,
                              "value-class": "text-right",
                            },
                          }),
                          _vm.purchase.supplier_requirements.supplier_reqs_a
                            ? _c(
                                "b-container",
                                [
                                  _c("text-row", {
                                    attrs: {
                                      compact: "",
                                      "label-cols-lg": 4,
                                      "label-cols-sm": 4,
                                      label: "Описание требований",
                                      value:
                                        _vm.purchase.supplier_requirements
                                          .supplier_reqs_a_details
                                          .supplier_reqs_a_text,
                                      "text-wrap": "",
                                    },
                                  }),
                                  _c(
                                    "b-form-group",
                                    {
                                      staticClass: "mb-0",
                                      attrs: {
                                        "label-cols-sm": 4,
                                        "label-cols-lg": 4,
                                        label: "Подтверждающие документы:",
                                        "label-class":
                                          "fs-14 grey-color fw-700 d-flex align-items-baseline",
                                      },
                                    },
                                    [
                                      _c(
                                        "ul",
                                        _vm._l(
                                          _vm.purchase.supplier_requirements
                                            .supplier_reqs_a_details
                                            .supplier_reqs_a_documents,
                                          function (item, index) {
                                            return _c(
                                              "li",
                                              {
                                                key: index,
                                                staticClass:
                                                  "fs-14 grey-color my-auto col-form-label pb-0",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    index +
                                                      1 +
                                                      ". " +
                                                      item.description
                                                  )
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c("text-row-boolean-text", {
                            attrs: {
                              compact: "",
                              "label-cols-lg": 11,
                              "label-cols-sm": 11,
                              label:
                                "Соответствие участника закупки требованиям п.3-5, 7-11 ч.1 ст.31 Федерального закона «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» от 05.04.2013 №44-ФЗ",
                              value:
                                _vm.purchase.supplier_requirements
                                  .supplier_reqs_b,
                              "value-class": "text-right",
                            },
                          }),
                          _c("text-row-boolean-text", {
                            attrs: {
                              compact: "",
                              "label-cols-lg": 11,
                              "label-cols-sm": 11,
                              label:
                                "Соответствие участника закупки требованиям ч.1.1 ст.31 Федерального закона «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» от 05.04.2013 №44-ФЗ",
                              value:
                                _vm.purchase.supplier_requirements
                                  .supplier_reqs_c,
                              "value-class": "text-right",
                            },
                          }),
                          _c("text-row-boolean-text", {
                            attrs: {
                              compact: "",
                              "label-cols-lg": 11,
                              "label-cols-sm": 11,
                              label:
                                "Участник является социально ориентированной некоммерческой организацией (СОНКО)",
                              value:
                                _vm.purchase.supplier_requirements
                                  .supplier_reqs_sonko,
                              "value-class": "text-right",
                            },
                          }),
                          _c("text-row-boolean-text", {
                            attrs: {
                              compact: "",
                              "label-cols-lg": 11,
                              "label-cols-sm": 11,
                              label:
                                "Дополнительные требования к участникам закупки",
                              value:
                                _vm.purchase.supplier_requirements
                                  .has_additional_requirements,
                              "value-class": "text-right",
                            },
                          }),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.purchase.supplier_requirements
                                      .has_additional_requirements,
                                  expression:
                                    "purchase.supplier_requirements.has_additional_requirements",
                                },
                              ],
                            },
                            [
                              _c(
                                "section",
                                { staticStyle: { width: "100%" } },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "table-responsive" },
                                    [
                                      _c(
                                        "table",
                                        {
                                          staticClass:
                                            "atmo-content-table mb-0",
                                        },
                                        [
                                          _c("thead", [
                                            _c("tr", [
                                              _c(
                                                "th",
                                                {
                                                  staticClass:
                                                    "atmo-ctc-width-45pct py-1",
                                                },
                                                [_vm._v("Описание")]
                                              ),
                                              _c(
                                                "th",
                                                {
                                                  staticClass:
                                                    "atmo-ctc-width-45pct py-1",
                                                },
                                                [
                                                  _vm._v(
                                                    "Причина или цель установки требования"
                                                  ),
                                                ]
                                              ),
                                            ]),
                                          ]),
                                          _c(
                                            "tbody",
                                            _vm._l(
                                              _vm.purchase.supplier_requirements
                                                .additional_requirements,
                                              function (requirement, index) {
                                                return _c(
                                                  "tr",
                                                  { key: index },
                                                  [
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "atmo-ctc-width-45pct py-1",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            requirement.description
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "atmo-ctc-width-45pct py-1",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            requirement.reason
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm.purchase.delivery_terms.addresses.length > 0 ||
                          _vm.purchase.delivery_terms.schedule
                            ? [
                                _c("hr"),
                                _c("h4", { staticClass: "font-weight-bold" }, [
                                  _vm._v("Условия поставки"),
                                ]),
                                _vm.purchase.delivery_terms.addresses.length > 0
                                  ? _c(
                                      "b-form-group",
                                      {
                                        staticClass: "mb-0",
                                        attrs: {
                                          "label-cols-sm": 4,
                                          "label-cols-lg": 4,
                                          label:
                                            "Адреса для доставки/самовывоза:",
                                          "label-class":
                                            "fs-14 grey-color fw-700 d-flex align-items-baseline",
                                        },
                                      },
                                      [
                                        _c(
                                          "ul",
                                          _vm._l(
                                            _vm.purchase.delivery_terms
                                              .addresses,
                                            function (address, index) {
                                              return _c(
                                                "li",
                                                {
                                                  key: index,
                                                  staticClass:
                                                    "fs-14 grey-color my-auto col-form-label pb-0",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      index +
                                                        1 +
                                                        ". " +
                                                        address.address ??
                                                        address
                                                    )
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c("text-row", {
                                  attrs: {
                                    compact: "",
                                    "label-cols-lg": 4,
                                    "label-cols-sm": 4,
                                    label:
                                      "График поставки товаров (выполнения работ, оказания услуг)",
                                    value: _vm.purchase.delivery_terms.schedule,
                                    "text-wrap": "",
                                  },
                                }),
                              ]
                            : _vm._e(),
                          _c("hr"),
                          _c("h4", { staticClass: "font-weight-bold" }, [
                            _vm._v("Спецификация"),
                          ]),
                          _vm.purchase.deliverables.length > 0
                            ? _c("b-form-group", [
                                _c(
                                  "ul",
                                  _vm._l(
                                    _vm.purchase.deliverables,
                                    function (item, index) {
                                      return _c(
                                        "li",
                                        {
                                          key: index,
                                          staticClass:
                                            "fs-14 grey-color my-auto col-form-label py-1",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(index + 1 + ".") +
                                              " " +
                                              _vm._s(item.ktru_item.name) +
                                              " - " +
                                              _vm._s(
                                                item.ktru_item.okei_local_symbol
                                              )
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ])
                            : _vm._e(),
                          _vm.purchase.additional_documents.length > 0
                            ? [
                                _c("hr"),
                                _c("h4", { staticClass: "font-weight-bold" }, [
                                  _vm._v("Дополнительные документы"),
                                ]),
                                _c("text-row-documents", {
                                  attrs: {
                                    label: "Дополнительные документы",
                                    compact: "",
                                  },
                                  model: {
                                    value: _vm.purchase.additional_documents,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.purchase,
                                        "additional_documents",
                                        $$v
                                      )
                                    },
                                    expression: "purchase.additional_documents",
                                  },
                                }),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                      _c(
                        "b-tab",
                        {
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "title",
                                fn: function () {
                                  return [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "system_link-style fs-16",
                                      },
                                      [_vm._v("XML")]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            119620390
                          ),
                        },
                        [
                          !_vm.isSignedXml
                            ? _c("b-form-textarea", {
                                staticClass: "text-monospace fs-12",
                                attrs: {
                                  disabled: "",
                                  rows: "20",
                                  "no-resize": "",
                                  "no-auto-shrink": "",
                                  wrap: "off",
                                },
                                model: {
                                  value: _vm.formXml,
                                  callback: function ($$v) {
                                    _vm.formXml = $$v
                                  },
                                  expression: "formXml",
                                },
                              })
                            : _vm._e(),
                          _vm.isSignedXml
                            ? _c("b-form-textarea", {
                                staticClass: "text-monospace fs-12",
                                attrs: { disabled: "", rows: "20" },
                                model: {
                                  value: _vm.signedFormXml,
                                  callback: function ($$v) {
                                    _vm.signedFormXml = $$v
                                  },
                                  expression: "signedFormXml",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "w-100 px-3",
                  attrs: { slot: "modal-footer" },
                  slot: "modal-footer",
                },
                [
                  _c("text-row", {
                    attrs: {
                      label: "Сертификат",
                      value: _vm.certificate?.subjectName,
                    },
                  }),
                  _c(
                    "b-button",
                    {
                      staticClass: "mr-2 text-uppercase",
                      attrs: {
                        disabled: _vm.isDataSending,
                        variant: "custom-outline-secondary",
                      },
                      on: { click: _vm.cancelSignModal },
                    },
                    [_vm._v("Отмена")]
                  ),
                  !_vm.isSignedXml
                    ? _c(
                        "b-overlay",
                        {
                          staticClass: "d-inline-block",
                          attrs: {
                            show: _vm.isSigningXml,
                            opacity: "0.6",
                            rounded: "",
                            "spinner-small": "",
                            "spinner-variant": "primary",
                          },
                        },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "text-uppercase",
                              attrs: {
                                disabled: !_vm.certificate,
                                variant: "custom-green",
                              },
                              on: { click: _vm.signForm },
                            },
                            [_vm._v("Подписать")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isSignedXml
                    ? _c(
                        "b-overlay",
                        {
                          staticClass: "d-inline-block",
                          attrs: {
                            show: _vm.isDataSending,
                            opacity: "0.6",
                            rounded: "",
                            "spinner-small": "",
                            "spinner-variant": "primary",
                          },
                        },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "text-uppercase",
                              attrs: {
                                disabled: !_vm.certificate,
                                variant: "custom-green",
                              },
                              on: { click: _vm.sendData },
                            },
                            [_vm._v("Отправить")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }